import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import accountIcon from './../../img/account-icon.svg';
import accountExtractIcon from './../../img/account-extract-icon.png';
import phoneCompanyIcon from './../../img/phone-company-icon.svg';
import { request, requestCardStorage } from './../../../../config';
import masterCardIcon from './../../img/card-icon.svg';
import visaCardIcon from './../../img/visa-icon.svg'
import DropdownWithChevron from './../../../../copms/DropdownWithChevron/DropdownWithChevron';
import { translate } from 'react-i18next';
import $ from 'jquery';
import Loading from './../../Loading/Loading';
import { cardTypes, maskCardNumber, setPaymentTypeIcon } from '../../../../helpers/cards';
import OutsideClickHandler from 'react-outside-click-handler';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class CardExtract extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iban: null,
            statements: [],
            startDate: null,
            endDate: null,
            visibleStartDate: null,
            visibleEndDate: null,
            card: null,
            selected: 'Pdf',
            isLoading: false,
            c2cStatusesSelectedIndex: 0,
            c2cStatuses: [
                {
                    c2cStatus: null,
                    name: 'all',
                },
                {
                    c2cStatus: 1,
                    name: 'Income'
                },
                {
                    c2cStatus: 2,
                    name: 'Outcome'
                }
            ],
            dropdownVisibilityC2cStatuses: false,
            currentPage: 1,
            lastPage: 0,
            dateRangeFilter: 'today',
        }
        this.updateDate = this.updateDate.bind(this);
    }
    updateSelected = (value) => {
        this.setState({ selected: value });
    }

    isSameDay = (firstDate, secondDate) => {
        if (!firstDate && !secondDate) return true;
        if (!firstDate || !secondDate) return false;

        const first = new Date(firstDate);
        const second = new Date(secondDate);

        return first.getFullYear() === second.getFullYear()
            && first.getMonth() === second.getMonth()
            && first.getDate() === second.getDate();
    }

    updateDate(name, value) {
        this.setState(prevState => {
            const previousValue = prevState[name];
            const dateChanged = !this.isSameDay(previousValue, value);

            if (!dateChanged) {
                return { [name]: value };
            }

            return { [name]: value, dateRangeFilter: 'none' };
        });
    }
    getFormatedDate(date) {
        if (date) {
            let formatedDate = {
                day: (date.getDate() < 9) ? ('0' + date.getDate()) : date.getDate(),
                month: (date.getMonth() < 9) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1),
                year: date.getFullYear().toString()
            }
            return formatedDate.day + '.' + formatedDate.month + '.' + formatedDate.year;
        }
        return null;
    }
    showStatements = (startDate = this.state.startDate, endDate = this.state.endDate, initial) => {
        if (initial) {
            this.setState({ isLoading: true });
        }
        else {
            this.props.updateAppState('isLoadingTransparentBackground', true);
        }
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let c2cStatus = this.state.c2cStatuses[this.state.c2cStatusesSelectedIndex].c2cStatus
        let getCardStatementForCustomerRequestBody = customerType == 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            cardNumber: this.state.card.cardNumber,
            cardId: this.state.card.cardId,
            startDate: this.getFormatedDate(startDate),
            endDate: this.getFormatedDate(endDate),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            pageNumber: this.state.currentPage
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            cardNumber: this.state.card.cardNumber,
            cardId: this.state.card.cardId,
            startDate: this.getFormatedDate(startDate),
            endDate: this.getFormatedDate(endDate),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            pageNumber: this.state.currentPage
        }

        fetch(request(`card/get${c2cStatus === 1 ? 'Credit' : c2cStatus === 2 ? 'Debit' : 'Card'}StatementFor${customerType}Customer`, getCardStatementForCustomerRequestBody))
            .then(res => res.text())
            .then((getCardStatementForCustomerResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getCardStatementForCustomerResponse = JSON.parse(getCardStatementForCustomerResponseJSON);
                if (getCardStatementForCustomerResponse.status.statusCode !== 1 && getCardStatementForCustomerResponse.status.statusCode !== 165) {
                    if (getCardStatementForCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getCardStatementForCustomerResponse.status.statusCode));
                        if (initial) {
                            this.setState({ isLoading: false });
                        }
                        else {
                            this.props.updateAppState('isLoadingTransparentBackground', false);
                        }
                    }
                }
                else {
                    if (getCardStatementForCustomerResponse.status.statusCode === 165) {
                        getCardStatementForCustomerResponse.cardStamentList = [];
                    }
                    this.setState({ lastPage: getCardStatementForCustomerResponse.pageCount ? getCardStatementForCustomerResponse.pageCount : 0 })

                    for (let i = 0; i < getCardStatementForCustomerResponse.cardStamentList.length; i++) {
                        // =========AMOUNT=========
                        if (!getCardStatementForCustomerResponse.cardStamentList[i].dtAmount || getCardStatementForCustomerResponse.cardStamentList[i].dtAmount === 0) {
                            getCardStatementForCustomerResponse.cardStamentList[i].amount = getCardStatementForCustomerResponse.cardStamentList[i].crAmount;
                            getCardStatementForCustomerResponse.cardStamentList[i].account = getCardStatementForCustomerResponse.cardStamentList[i].dtAccount;

                        }
                        else {
                            if (!getCardStatementForCustomerResponse.cardStamentList[i].crAmount || getCardStatementForCustomerResponse.cardStamentList[i].crAmount === 0) {
                                getCardStatementForCustomerResponse.cardStamentList[i].amount = getCardStatementForCustomerResponse.cardStamentList[i].dtAmount;
                                getCardStatementForCustomerResponse.cardStamentList[i].account = getCardStatementForCustomerResponse.cardStamentList[i].crAccount;
                            }
                        }
                        if (getCardStatementForCustomerResponse.cardStamentList[i].amount.toString() === "0") {
                            getCardStatementForCustomerResponse.cardStamentList[i].amount = {
                                wholePart: "0",
                                fractionalPart: "00"
                            }
                        }
                        else {
                            if (getCardStatementForCustomerResponse.cardStamentList[i].amount.toString().indexOf('.') !== -1) {
                                let amountArray = getCardStatementForCustomerResponse.cardStamentList[i].amount.toString().split('.');
                                getCardStatementForCustomerResponse.cardStamentList[i].amount = {
                                    wholePart: amountArray[0],
                                    fractionalPart: (amountArray[1].length === 1) ? (amountArray[1] + '0') : amountArray[1]
                                }
                            }
                            else {
                                let amountArray = getCardStatementForCustomerResponse.cardStamentList[i].amount.toString().split('.');
                                getCardStatementForCustomerResponse.cardStamentList[i].amount = {
                                    wholePart: getCardStatementForCustomerResponse.cardStamentList[i].amount.toString(),
                                    fractionalPart: "00"
                                }
                            }
                        }
                    }
                    this.setState({ statements: getCardStatementForCustomerResponse.cardStamentList });
                    if (initial) {
                        this.setState({ isLoading: false });
                    }
                    else {
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    showOtherCardStatement = (initial) => {
        if (initial) {
            this.setState({ isLoading: false });
        }
        else {
            this.props.updateAppState('isLoadingTransparentBackground', true);
        }

        let requestBody = {
            token: localStorage.getItem('token'),
            pageNumber: this.state.currentPage,
            cardId: this.props.match.params.id
        }
        fetch(requestCardStorage("storage/getCardStorageOperationHistory", requestBody))
            .then(res => res.text())
            .then((getCardStatementForCustomerResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getCardStatementForCustomerResponse = JSON.parse(getCardStatementForCustomerResponseJSON);
                if (getCardStatementForCustomerResponse.status.statusCode !== 1 && getCardStatementForCustomerResponse.status.statusCode !== 165) {
                    if (getCardStatementForCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        if (initial) {
                            this.setState({ isLoading: false });
                        }
                        else {
                            this.props.updateAppState('isLoadingTransparentBackground', false);
                        }
                    }
                }
                else {
                    if (getCardStatementForCustomerResponse.status.statusCode === 165) {
                        getCardStatementForCustomerResponse.cardStamentList = [];
                        if (initial) {
                            this.setState({ isLoading: false });
                        }
                        else {
                            this.props.updateAppState('isLoadingTransparentBackground', false);
                        }
                    }
                    this.setState({ lastPage: getCardStatementForCustomerResponse.pageCount ? getCardStatementForCustomerResponse.pageCount : 0 })
                    for (let i = 0; i < getCardStatementForCustomerResponse.cardStorageOperInfos.length; i++) {
                        // =========NUMBER=========
                        getCardStatementForCustomerResponse.cardStorageOperInfos[i].organizedCardNumber = getCardStatementForCustomerResponse.cardStorageOperInfos[i].cardNumber.substring(0, 4)
                            + " **** **** " + getCardStatementForCustomerResponse.cardStorageOperInfos[i].cardNumber.substring(12, 16);
                        // =========DATE=========
                        //   getCardStatementForCustomerResponse.cardStorageOperInfos[i].organizedDate = getCardStatementForCustomerResponse.cardStorageOperInfos[i].operDate.substring(0, getCardStatementForCustomerResponse.cardStorageOperInfos[i].operDate.length - 3);
                        // =========AMOUNT=========
                        if (getCardStatementForCustomerResponse.cardStorageOperInfos[i].amount.toString() === "0") {
                            getCardStatementForCustomerResponse.cardStorageOperInfos[i].amount = {
                                wholePart: "0",
                                fractionalPart: "00"
                            }
                        }
                        else {
                            if (getCardStatementForCustomerResponse.cardStorageOperInfos[i].amount.toString().indexOf('.') !== -1) {
                                let amountArray = getCardStatementForCustomerResponse.cardStorageOperInfos[i].amount.toString().split('.');
                                getCardStatementForCustomerResponse.cardStorageOperInfos[i].amount = {
                                    wholePart: amountArray[0],
                                    fractionalPart: (amountArray[1].length === 1) ? (amountArray[1] + '0') : amountArray[1]
                                }
                            }
                            else {
                                let amountArray = getCardStatementForCustomerResponse.cardStorageOperInfos[i].amount.toString().split('.');
                                getCardStatementForCustomerResponse.cardStorageOperInfos[i].amount = {
                                    wholePart: getCardStatementForCustomerResponse.cardStorageOperInfos[i].amount.toString(),
                                    fractionalPart: "00"
                                }
                            }
                        }
                    }
                    this.setState({ statements: getCardStatementForCustomerResponse.cardStorageOperInfos });
                    if (initial) {
                        this.setState({ isLoading: false });
                    }
                    else {
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });

    }

    showCard = () => {
        this.setState({ isLoading: true });
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let getCardByIdForCustomerRequestBody = (customerType === 'Individual') ? {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }


        fetch(request("card/getCardByIdFor" + customerType, getCardByIdForCustomerRequestBody))
            .then(res => res.text())
            .then((getCardByIdForCustomerResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getCardByIdForCustomerResponse = JSON.parse(getCardByIdForCustomerResponseJSON);
                if (getCardByIdForCustomerResponse.status.statusCode !== 1) {
                    if (getCardByIdForCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.setState({ isLoading: false });
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getCardByIdForCustomerResponse.status.statusCode));
                    }
                }
                else {
                    if (getCardByIdForCustomerResponse?.otherCard) {
                        this.setState({ card: getCardByIdForCustomerResponse.otherCard });
                        this.setState({ isLoading: false });
                        this.showOtherCardStatement(true);
                    } else {
                        // =========HOLDER=========
                        let holderArray = getCardByIdForCustomerResponse.holder.split(' ');
                        let lowercaseName = holderArray[0].toLowerCase();
                        let lowercaseSurname = holderArray[1].toLowerCase();
                        getCardByIdForCustomerResponse.organizedHolder = {
                            name: holderArray[0][0] + lowercaseName.substring(1, lowercaseName.length),
                            surname: holderArray[1][0] + lowercaseSurname.substring(1, lowercaseSurname.length)
                        };
                        // =========NUMBER=========
                        getCardByIdForCustomerResponse.organizedCardNumber = getCardByIdForCustomerResponse.cardNumber.substring(0, 4)
                            + " **** **** " + getCardByIdForCustomerResponse.cardNumber.substring(12, 16);
                        this.setState({ card: getCardByIdForCustomerResponse });
                        let today = new Date();
                        this.setState({ startDate: today, endDate: today, visibleStartDate: today, visibleEndDate: today });
                        this.showStatements(new Date(), new Date(), true);
                    }
                }
            }, (error) => {
                this.props.history.push("/technical-break");

            });


    }

    searchStatements = () => {
        this.setState({ visibleStartDate: this.state.startDate, visibleEndDate: this.state.endDate });
        this.showStatements(this.state.startDate, this.state.endDate, false);
    }
    componentWillMount() {
        this.showCard();
    }

    extractExcel() {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let getCardStatementCustomerExcelByteArrayRequestBody = customerType == 'Juridical' ? {
            startDate: this.getFormatedDate(this.state.startDate),
            endDate: this.getFormatedDate(this.state.endDate),
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            startDate: this.getFormatedDate(this.state.startDate),
            endDate: this.getFormatedDate(this.state.endDate),
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }

        fetch(request("card/getCardStatement" + customerType + "ExcelByteArray", getCardStatementCustomerExcelByteArrayRequestBody))
            .then(res => res.json())
            .then((getCardStatementCustomerResponse) => {
                if (getCardStatementCustomerResponse.status.statusCode !== 1) {
                    if (getCardStatementCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getCardStatementCustomerResponse.status.statusCode));
                    }
                }
                else {
                    let arrrayBuffer = base64ToArrayBuffer(getCardStatementCustomerResponse.bytes); //data is the base64 encoded string
                    saveFile(this.props.t('Card_Extract') + "_" + this.getFormatedDate(this.state.startDate) + "-" + this.getFormatedDate(this.state.endDate) + ".xlsx", "application/xlsx", arrrayBuffer)
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    extractPdf() {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let getCardStatementCustomerPdfByteArrayRequestBody = customerType == 'Juridical' ? {
            startDate: this.getFormatedDate(this.state.startDate),
            endDate: this.getFormatedDate(this.state.endDate),
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            startDate: this.getFormatedDate(this.state.startDate),
            endDate: this.getFormatedDate(this.state.endDate),
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            cardId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("card/getCardStatement" + customerType + "PdfByteArray", getCardStatementCustomerPdfByteArrayRequestBody))
            .then(res => res.json())
            .then((getCardStatementCustomerResponse) => {
                if (getCardStatementCustomerResponse.status.statusCode !== 1) {
                    if (getCardStatementCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getCardStatementCustomerResponse.status.statusCode));
                    }
                }
                else {
                    let arrrayBuffer = base64ToArrayBuffer(getCardStatementCustomerResponse.bytes); //data is the base64 encoded string
                    let blob = new Blob([arrrayBuffer], { type: "application/pdf" });
                    let link = window.URL.createObjectURL(blob);
                    var newWin = window.open(link, '');
                    if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
                        saveFile(this.props.t('Card_Extract') + "_" + this.getFormatedDate(this.state.startDate) + "-" + this.getFormatedDate(this.state.endDate) + ".pdf", "application/pdf", arrrayBuffer)
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }


    selectPage(e, page, cardType) {
        e.preventDefault();
        if (cardType === cardTypes.CARD_STORAGE) {
            this.setState({ currentPage: page }, () => this.showOtherCardStatement())
        } else {
            this.setState({ currentPage: page }, () => this.showStatements())
        }
    }

    setPresetRange = (range) => {
        const today = new Date();
        let startDate = new Date(today);
        let endDate = new Date(today);

        if (range === 'thisWeek') {
            const dayIndex = today.getDay();
            const monday = new Date(today);
            monday.setDate(today.getDate() - ((dayIndex + 6) % 7));
            startDate = monday;
        } else if (range === 'thisMonth') {
            startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        }

        this.setState({ startDate, endDate, dateRangeFilter: range });
    }

    render() {
        let { iban, statements, visibleStartDate, visibleEndDate, card, selected, isLoading, c2cStatusesSelectedIndex, c2cStatuses, dropdownVisibilityC2cStatuses, dateRangeFilter, startDate, endDate } = this.state;
        let dateTitle = null;
        let { t } = this.props;

        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('extract')}</h2>
                    </div>
                    <Link to="/dashboard/finance/cards" className="dashboard-header-route-link">{t('ALL CARDS')}</Link>
                </div>
                <div className="dashboard-container-main-section dashboard-container-main-section--column dashboard-container-main-section--white">
                    {
                        isLoading ?
                            <Loading />
                            :
                            <div className="dashboard-finance-section-account-extract-section">
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, background: '#E3EAED', paddingBottom: 8 }}>
                                    <button type="button" onClick={() => this.setPresetRange('today')} style={{ background: dateRangeFilter === 'today' ? '#0066B2' : '#fff', color: dateRangeFilter === 'today' ? '#fff' : '#2E3131', border: '1px solid #E8ECEF', borderRadius: 24, padding: '8px 14px', cursor: 'pointer' }}>
                                        {t('today')}
                                    </button>
                                    <button type="button" onClick={() => this.setPresetRange('thisWeek')} style={{ background: dateRangeFilter === 'thisWeek' ? '#0066B2' : '#fff', color: dateRangeFilter === 'thisWeek' ? '#fff' : '#2E3131', border: '1px solid #E8ECEF', borderRadius: 24, padding: '8px 14px', cursor: 'pointer' }}>
                                        {t('this week')}
                                    </button>
                                    <button type="button" onClick={() => this.setPresetRange('thisMonth')} style={{ background: dateRangeFilter === 'thisMonth' ? '#0066B2' : '#fff', color: dateRangeFilter === 'thisMonth' ? '#fff' : '#2E3131', border: '1px solid #E8ECEF', borderRadius: 24, padding: '8px 14px', cursor: 'pointer' }}>
                                        {t('this month')}
                                    </button>
                                </div>
                                {
                                    card.cardType !== cardTypes.CARD_STORAGE &&
                                    <div className="dashboard-finance-section-account-extract-section-search-section">

                                        <div className="dashboard-finance-section-account-extract-section-search-section-box pt-1">
                                            <StartDatePicker placeholder="Başlama tarixi" value={startDate} updateDate={this.updateDate} />
                                        </div>
                                        <div className="dashboard-finance-section-account-extract-section-search-section-box pt-1">
                                            <EndDatePicker placeholder="Bitmə tarixi" value={endDate} updateDate={this.updateDate} />
                                        </div>
                                        <div className="dashboard-finance-section-account-extract-section-search-section-box pt-1">
                                            <OutsideClickHandler onOutsideClick={() => { this.setState({ dropdownVisibilityC2cStatuses: false }) }}>
                                                <div className="dashboard-payment-container-data-section-content-container-form-select-box">
                                                    <button className="dashboard-payment-container-data-section-content-container-form-select-box-button border-0" onClick={() => this.setState({ dropdownVisibilityC2cStatuses: !dropdownVisibilityC2cStatuses })}>
                                                        {
                                                            c2cStatusesSelectedIndex >= 0 ?
                                                                <div className="dashboard-payment-container-data-section-content-container-form-select">{t(c2cStatuses[c2cStatusesSelectedIndex]?.name)}</div>
                                                                :
                                                                <div className="dashboard-payment-container-data-section-content-container-form-select" style={{ color: '#BDC3C7' }}>{t("all")}</div>
                                                        }
                                                        <div className="dashboard-payment-container-data-section-content-container-form-icon">
                                                            <svg className="dashboard-payment-container-data-section-content-container-form-icon-img" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path id="chevron-down copy 2" d="M12.4336 1.34375L11.9141 0.796875C11.7773 0.660156 11.5586 0.660156 11.4492 0.796875L6.5 5.74609L1.52344 0.796875C1.41406 0.660156 1.19531 0.660156 1.05859 0.796875L0.539063 1.34375C0.402344 1.45312 0.402344 1.67188 0.539063 1.80859L6.25391 7.52344C6.39063 7.66016 6.58203 7.66016 6.71875 7.52344L12.4336 1.80859C12.5703 1.67187 12.5703 1.45312 12.4336 1.34375Z" fill="#849097" />
                                                            </svg>
                                                        </div>
                                                    </button>
                                                    {
                                                        c2cStatuses.length !== 0 &&
                                                        <ul className={(dropdownVisibilityC2cStatuses === false) ? "dashboard-payment-container-data-section-content-container-form-select-box-list dashboard-payment-container-data-section-content-container-form-select-box-list__hidden" : "dashboard-payment-container-data-section-content-container-form-select-box-list border-0 mt-1"}>
                                                            {
                                                                c2cStatuses.map((status, index) => (
                                                                    <li className="dashboard-payment-container-data-section-content-container-form-select-box-list-item" key={index}>
                                                                        <button type="button" className="dashboard-payment-container-data-section-content-container-form-select-box-list-item-button" onClick={() => this.setState({ c2cStatusesSelectedIndex: index, dropdownVisibilityC2cStatuses: false })}>{t(status?.name)}</button>
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>
                                                    }
                                                </div>
                                            </OutsideClickHandler>
                                        </div>
                                        <button className="dashboard-finance-section-account-extract-section-search-section-box-button" onClick={this.searchStatements}>{t("Search")}</button>
                                    </div>
                                }
                                <div className="dashboard-finance-section-account-extract-section-main-section">
                                    <div className="dashboard-finance-section-account-extract-section-main-section-header">
                                        <div className="dashboard-finance-section-account-extract-section-main-section-header--left-side">
                                            {
                                                card !== null && card.cardId !== undefined ?
                                                    <div className="dashboard-finance-section-card-section-details-section-header-left-side">
                                                        <img src={setPaymentTypeIcon(card.cardPaymentType, masterCardIcon, visaCardIcon)} className="dashboard-finance-section-card-section-details-section-header-image" alt="cardIcon" />
                                                        <h3 className="dashboard-finance-section-card-section-details-section-header-card-number">{card.cardType === cardTypes.CARD_STORAGE ? maskCardNumber(card.cardNumber) : card.organizedCardNumber}</h3>
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                        {
                                            card.cardType !== cardTypes.CARD_STORAGE &&
                                            <div className="dashboard-finance-section-account-extract-section-main-section-header--right-side">
                                                <div className="dashboard-finance-section-account-extract-section-main-section-header-history">
                                                    <svg className="dashboard-finance-section-account-extract-section-main-section-header-history-icon" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.5312 3.0625L8.9375 0.4375C8.65625 0.15625 8.25 0 7.875 0H1.5C0.65625 0 0 0.6875 0 1.5V14.5C0 15.3438 0.65625 16 1.5 16H10.5C11.3125 16 12 15.3438 12 14.5V4.125C12 3.75 11.8125 3.34375 11.5312 3.0625ZM10.8438 3.78125C10.9062 3.84375 10.9375 3.9375 10.9688 4H8V1.03125C8.0625 1.0625 8.15625 1.09375 8.21875 1.15625L10.8438 3.78125ZM10.5 15H1.5C1.21875 15 1 14.7812 1 14.5V1.5C1 1.25 1.21875 1 1.5 1H7V4.25C7 4.6875 7.3125 5 7.75 5H11V14.5C11 14.7812 10.75 15 10.5 15ZM9 7.375C9 7.1875 8.8125 7 8.625 7H3.375C3.15625 7 3 7.1875 3 7.375V7.625C3 7.84375 3.15625 8 3.375 8H8.625C8.8125 8 9 7.84375 9 7.625V7.375ZM9 9.375C9 9.1875 8.8125 9 8.625 9H3.375C3.15625 9 3 9.1875 3 9.375V9.625C3 9.84375 3.15625 10 3.375 10H8.625C8.8125 10 9 9.84375 9 9.625V9.375ZM9 11.375C9 11.1875 8.8125 11 8.625 11H3.375C3.15625 11 3 11.1875 3 11.375V11.625C3 11.8438 3.15625 12 3.375 12H8.625C8.8125 12 9 11.8438 9 11.625V11.375Z" fill="#849097" />
                                                    </svg>
                                                    <span className="dashboard-finance-section-account-extract-section-main-section-header-title">{t('date')}</span>
                                                    <span className="dashboard-finance-section-account-extract-section-main-section-header-content">{this.getFormatedDate(visibleStartDate)} - {this.getFormatedDate(visibleEndDate)}</span>
                                                </div>
                                                <div className="dashboard-finance-section-account-extract-section-main-section-header-download">
                                                    <span className="dashboard-finance-section-account-extract-section-main-section-header-title">{t('download')}</span>
                                                    <DropdownWithChevron
                                                        dropdownItems={['Pdf', 'Excel']} updateSelected={this.updateSelected} selected={selected} />
                                                    <button disabled={statements.length === 0} onClick={() => selected === "Pdf" ? this.extractPdf() : this.extractExcel()} className="dashboard-finance-section-account-extract-section-main-section-header-download-button">
                                                        <svg className="dashboard-finance-section-account-extract-section-main-section-header-download-icon" width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10.875 7.25C11.0312 7.125 11.0312 6.875 10.875 6.75L10.6562 6.5C10.5 6.375 10.2812 6.375 10.125 6.5L6.53125 10.125V0.375C6.53125 0.1875 6.34375 0 6.15625 0H5.84375C5.625 0 5.46875 0.1875 5.46875 0.375V10.125L1.84375 6.5C1.6875 6.375 1.46875 6.375 1.3125 6.5L1.09375 6.71875C0.9375 6.875 0.9375 7.125 1.09375 7.25L5.71875 11.9062C5.875 12.0625 6.09375 12.0625 6.25 11.9062L10.875 7.25ZM12 13.625V13.375C12 13.1875 11.8125 13 11.625 13H0.375C0.15625 13 0 13.1875 0 13.375V13.625C0 13.8438 0.15625 14 0.375 14H11.625C11.8125 14 12 13.8438 12 13.625Z" fill="#2E3131" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {
                                        statements.length === 0 ?
                                            <div className="dashboard-finance-section-account-extract-section-main-section-invisible-content-section">
                                                <img src={accountExtractIcon} className="dashboard-finance-section-account-extract-section-main-section-invisible-content-section-image" />
                                                <div className="dashboard-finance-section-account-extract-section-main-section-invisible-content-section-paragraph">
                                                    <p className="dashboard-finance-section-account-extract-section-main-section-invisible-content-section-text">{t('Search no matching operation found')}</p>
                                                </div>
                                            </div>
                                            :
                                            <div className="dashboard-finance-section-account-extract-section-main-section-visible-content-section">
                                                <ul className="dashboard-finance-section-account-extract-section-list">
                                                    {
                                                        statements.map((statement, index) => {
                                                            if (card.cardType !== cardTypes.CARD_STORAGE && dateTitle !== statement.trDate.substring(0, 10)) {
                                                                dateTitle = statement.trDate.substring(0, 10);
                                                                return [
                                                                    <li className="dashboard-finance-section-account-extract-section-list-date-item" key={index + Math.random(10, 100)}>{statement.trDate.substring(0, 10)}</li>,
                                                                    <li className="dashboard-finance-section-account-extract-section-list-extract-item" key={index}>
                                                                        <div className="dashboard-finance-section-account-extract-section-list-extract-item--left-side">
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-icon-container">
                                                                                <svg className="dashboard-finance-section-account-extract-section-list-extract-item-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M0.625 0.75C0.40625 0.75 0.25 0.9375 0.25 1.125V5.625C0.25 5.84375 0.40625 6 0.625 6H5.125C5.3125 6 5.5 5.84375 5.5 5.625V5.3125C5.5 5.125 5.3125 4.9375 5.125 4.9375H2.03125C3.15625 2.8125 5.40625 1.3125 8 1.3125C11.6875 1.3125 14.6875 4.34375 14.6875 8C14.6875 11.7188 11.6562 14.6875 8 14.6875C6.25 14.6875 4.6875 14.0625 3.5 13C3.375 12.8438 3.125 12.875 3 13L2.78125 13.2188C2.625 13.375 2.625 13.625 2.78125 13.7812C4.15625 15 6 15.75 8 15.75C12.25 15.75 15.7188 12.3125 15.75 8.03125C15.75 3.78125 12.2812 0.28125 8 0.28125C5.15625 0.25 2.65625 1.8125 1.3125 4.09375V1.125C1.3125 0.9375 1.125 0.75 0.9375 0.75H0.625ZM10.6562 10.625L10.8125 10.4062C10.9375 10.25 10.9062 10 10.7188 9.90625L8.5 8.25V3.625C8.5 3.4375 8.3125 3.25 8.125 3.25H7.875C7.65625 3.25 7.5 3.4375 7.5 3.625V8.78125L10.125 10.6875C10.3125 10.8125 10.5312 10.7812 10.6562 10.625Z" fill="#849097" />
                                                                                </svg>
                                                                            </div>
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-date-container">
                                                                                <div className="dashboard-finance-section-account-extract-section-list-extract-item-title">{statement.trDate.split(" ")[0]}</div>
                                                                            </div>
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-date-container">
                                                                                <div className="dashboard-finance-section-account-extract-section-list-extract-item-title">{card.cardType === cardTypes.CARD_STORAGE ? statement.name : statement.purpose}</div>
                                                                            </div>
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-description-container">
                                                                                <div className="dashboard-finance-section-account-extract-section-list-extract-item-title">{statement.rrn}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="dashboard-finance-section-account-extract-section-list-extract-item--right-side">
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-title dashboard-finance-section-account-extract-section-list-extract-item-amount">
                                                                                <span className="dashboard-finance-section-account-extract-section-list-extract-item-amount-whole-part" style={{ color: statement.crAmount > 0 && '#40A900' }}>{statement.amount.wholePart}</span>
                                                                                <span className="dashboard-finance-section-account-extract-section-list-extract-item-amount-fractional-part" style={{ color: statement.crAmount > 0 && '#40A900' }}>{statement.amount.fractionalPart}</span>
                                                                                <span className="dashboard-finance-section-account-extract-section-list-extract-item-amount-currency" style={{ color: statement.crAmount > 0 && '#40A900' }}>{statement.currency}</span>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                ];
                                                            }
                                                            else {
                                                                return (
                                                                    <li className="dashboard-finance-section-account-extract-section-list-extract-item" key={index}>
                                                                        <div className="dashboard-finance-section-account-extract-section-list-extract-item--left-side">
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-icon-container">
                                                                                <svg className="dashboard-finance-section-account-extract-section-list-extract-item-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M0.625 0.75C0.40625 0.75 0.25 0.9375 0.25 1.125V5.625C0.25 5.84375 0.40625 6 0.625 6H5.125C5.3125 6 5.5 5.84375 5.5 5.625V5.3125C5.5 5.125 5.3125 4.9375 5.125 4.9375H2.03125C3.15625 2.8125 5.40625 1.3125 8 1.3125C11.6875 1.3125 14.6875 4.34375 14.6875 8C14.6875 11.7188 11.6562 14.6875 8 14.6875C6.25 14.6875 4.6875 14.0625 3.5 13C3.375 12.8438 3.125 12.875 3 13L2.78125 13.2188C2.625 13.375 2.625 13.625 2.78125 13.7812C4.15625 15 6 15.75 8 15.75C12.25 15.75 15.7188 12.3125 15.75 8.03125C15.75 3.78125 12.2812 0.28125 8 0.28125C5.15625 0.25 2.65625 1.8125 1.3125 4.09375V1.125C1.3125 0.9375 1.125 0.75 0.9375 0.75H0.625ZM10.6562 10.625L10.8125 10.4062C10.9375 10.25 10.9062 10 10.7188 9.90625L8.5 8.25V3.625C8.5 3.4375 8.3125 3.25 8.125 3.25H7.875C7.65625 3.25 7.5 3.4375 7.5 3.625V8.78125L10.125 10.6875C10.3125 10.8125 10.5312 10.7812 10.6562 10.625Z" fill="#849097" />
                                                                                </svg>
                                                                            </div>
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-date-container">
                                                                                <div className="dashboard-finance-section-account-extract-section-list-extract-item-title">{card.cardType === cardTypes.CARD_STORAGE ? statement.operDate.split(" ")[0] : statement.trDate.split(" ")[0]}</div>
                                                                            </div>
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-description-container">
                                                                                <div className="dashboard-finance-section-account-extract-section-list-extract-item-title">{card.cardType === cardTypes.CARD_STORAGE ? statement.name : statement.purpose}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="dashboard-finance-section-account-extract-section-list-extract-item--right-side">
                                                                            <div className="dashboard-finance-section-account-extract-section-list-extract-item-title dashboard-finance-section-account-extract-section-list-extract-item-amount">
                                                                                <span className="dashboard-finance-section-account-extract-section-list-extract-item-amount-whole-part" style={{ color: statement.crAmount > 0 && '#40A900' }}>{statement.amount.wholePart}</span>
                                                                                <span className="dashboard-finance-section-account-extract-section-list-extract-item-amount-fractional-part" style={{ color: statement.crAmount > 0 && '#40A900' }}>{statement.amount.fractionalPart}</span>
                                                                                <span className="dashboard-finance-section-account-extract-section-list-extract-item-amount-currency" style={{ color: statement.crAmount > 0 && '#40A900' }}>{statement.currency}</span>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                );
                                                            }
                                                        })
                                                    }
                                                </ul>
                                                <div style={{ width: '100%', marginTop: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                                                    <ul className="dashboard-pagination">
                                                        {this.state.currentPage != 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage - 1, card.cardType)}>{t('previous-page')}</a></li>}
                                                        {
                                                            Array.from({ length: this.state.lastPage }).map((item, index) => {
                                                                if (this.state.lastPage > 3) {
                                                                    if (this.state.currentPage - 1 == index + 1) {
                                                                        return (
                                                                            <>
                                                                                {this.state.currentPage > 2 && <li key={index}><a href="#" onClick={(e) => this.selectPage(e, 1, card.cardType)}>1</a></li>}

                                                                                {this.state.currentPage > 3 && <li key={index}><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                                                <li key={index}><a href="#" onClick={(e) => this.selectPage(e, index + 1, card.cardType)}>{index + 1}</a></li>
                                                                            </>
                                                                        )
                                                                    }
                                                                    if (this.state.currentPage == index + 1) {
                                                                        return (
                                                                            <>
                                                                                <li key={index} className="active" ><a href="#" style={{ cursor: 'default' }} onClick={e => e.preventDefault()}>{index + 1}</a></li>
                                                                            </>
                                                                        )
                                                                    }
                                                                    if (this.state.currentPage + 1 == index + 1) {
                                                                        return (
                                                                            <>
                                                                                <li key={index}><a href="#" onClick={(e) => this.selectPage(e, index + 1, card.cardType)}>{index + 1}</a></li>
                                                                                {this.state.currentPage < this.state.lastPage - 2 && <li key={index}><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}

                                                                                {this.state.currentPage + 1 < this.state.lastPage && <li key={index}><a href="#" onClick={(e) => this.selectPage(e, this.state.lastPage, card.cardType)}>{this.state.lastPage}</a></li>}
                                                                            </>
                                                                        )
                                                                    }
                                                                } else {
                                                                    return (
                                                                        <li key={index} className={index + 1 == this.state.currentPage ? "active" : ""}><a href="#" style={this.state.lastPage == 1 ? { borderRadius: '5px' } : {}} onClick={(e) => this.selectPage(e, index + 1, card.cardType)}>{index + 1}</a></li>
                                                                    )
                                                                }
                                                            })

                                                        }
                                                        {this.state.currentPage != this.state.lastPage && this.state.lastPage > 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage + 1, card.cardType)}>{t('next-page')}</a></li>}
                                                    </ul>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                    }
                </div>
            </>
        )
    }
}

export default translate("translation")(CardExtract);